import api from "../api";
import { API_URL } from "../constants";

export const getRecentActivity = async () => {
  return api.get(`${API_URL}/v1/activity/recent`);
};
